module.exports = __webpack_public_path__ + "static/media/landingPageImg.e9f7ca71.jpg";